import React from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { NavLink } from 'react-router';
import { Icons, Row } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import { intlShape } from '../../../../components/base/IntlProviderWrapper';
import {
  dateFormatter,
  dateTimeFormatter,
  infoFormatterIntl,
  localeFormatter,
  statusFormatter,
  subjectFormatter,
  userPositionFormatter,
} from '../../../../utils/formatters';
import FileView from '../../../../components/fields/FileInput/FileView';
import { getApplicantData } from '../../reducer';
import TimerLoader from '../../../../components/base/Loader/TimerLoader';
import { PROCEDURE_TYPE, USER_TYPE } from '../../../../configs';
import PersonView from '../../../Application/components/ViewBlocks/PersonView';
import JuridicalView from '../../../Application/components/ViewBlocks/JuridicalView';
import IndividualEntrepreneurView from '../../../Application/components/ViewBlocks/IndividualEntrepreneurView';
import Grid from '../../../../components/base/Grid/Grid';
import { applicantFieldFormatters } from './fieldFormatters';

export function ApplicantBox(props) {
  const {
    onClose = () => {},
  } = props;
  const {
    formatMessage,
  } = intlShape;

  const {
    loadingCurrentApplicant,
    currentApplicant = {},
    fieldsValidation = {
      checks: {},
      errors: {},
    },
  } = useSelector(getApplicantData);
  const { validation_result = null } = currentApplicant;
  const validationResult = validation_result?.length ? validation_result : [];
  const warningColumns = [
    {
      dataField: 'field',
      text: 'Поле',
      headerClassName: 'field-name',
      disableSort: true,
    },
    // {
    //   dataField: 'value',
    //   text: 'Значение',
    //   headerClassName: 'field-value',
    //   disableSort: true,
    // },
    {
      dataField: 'application_value',
      text: 'Значение в обращении',
      headerClassName: 'field-value',
      disableSort: true,
    },
    {
      dataField: 'dict_applicant_value',
      text: 'Значение в карточке заявителя',
      headerClassName: 'field-value',
      disableSort: true,
    },
  ];

  return (
    <div className="applicant-body">
      <TimerLoader loading={loadingCurrentApplicant} />
      <div className="applicant-main">
        <div className="applicant-main-title">
          <Icons width={24} height={24} customIcon icon="arrow-return" onClick={onClose} />
          <div className="f3">{formatMessage({ id: 'applicant.card.menu.applicant_1' })}</div>
          <NavLink
            to={{
              pathname: '/reference-information/user-activity-log',
              search: new URLSearchParams({
                subject_id: currentApplicant?.id,
              }).toString(),
            }}
            target="_blank"
          >
            <Icons
              customIcon
              icon="history-relation"
            />
          </NavLink>
        </div>
        <div className="f4 mt-3">Основная информация</div>
        <Row className="row-cols-2">
          {/* {infoFormatterIntl('legal_entity_type', localeFormatter('user.type', currentApplicant?.legal_entity_type), fieldsValidation, 'applicant.legal_entity_type')} */}
          {infoFormatterIntl('applicant_role', currentApplicant?.roles?.map(role => localeFormatter('applicant.roles', role)).join(','), fieldsValidation, 'applicant.roles')}
        </Row>
        {[USER_TYPE.PRIVATE_PERSON, USER_TYPE.PRIVATE_PERSON_OLD].includes(currentApplicant?.legal_entity_type) ? <PersonView fieldsValidation={fieldsValidation} applicant={currentApplicant} prefix="applicant." /> : null}
        {currentApplicant?.legal_entity_type === USER_TYPE.LEGAL ? <JuridicalView fieldsValidation={fieldsValidation} applicant={currentApplicant} prefix="applicant." /> : null}
        {currentApplicant?.legal_entity_type === USER_TYPE.INDIVIDUAL_ENTREPRENEUR ? <IndividualEntrepreneurView fieldsValidation={fieldsValidation} applicant={currentApplicant} prefix="applicant." /> : null}
        {currentApplicant?.legal_entity_type === USER_TYPE.PRIVATE_PERSON ? (
          <Row className="row-cols-1">
            {infoFormatterIntl('criminal_record_note', currentApplicant?.criminal_record_note || '', fieldsValidation, 'criminal_record_note')}
          </Row>
        ) : null}
      </div>
      <div className="applicant-additional">
        {validationResult?.length ? (
          <div className="application-warning-wrapper">
            <div className="f4">Несоответствия полей в обращениях</div>
            <div className="application-warning-list">
              {validationResult.map((item, index) => {
                const keys = Object.keys(item);
                if (!keys?.length) { return null; }
                const gridData = keys.map(k => {
                  let formatter = v => v;
                  if (applicantFieldFormatters[k]) {
                    formatter = applicantFieldFormatters[k];
                  }
                  return {
                    field: formatMessage({ id: k, defaultMessage: k || ' ' }),
                    application_value: formatter(item?.[k]?.application_value || ''),
                    dict_applicant_value: formatter(item?.[k]?.dict_applicant_value || ''),
                  };
                });
                return (
                  <div key={`application-warning-${index}`} className="application-warning-block">
                    <div className="application-warning-info" onClick={() => window.open(`/application?application_id=${item?.[keys[0]]?.application?.id || ''}`, '_blank')}>
                      Обращение № {item?.[keys[0]]?.application?.mais_egu_id || 'Без номера'}
                    </div>
                    <div className="application-warning-fields">
                      <Grid
                        data={gridData}
                        columns={warningColumns}
                        name="application-list"
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}
